import React from 'react';
import { observer } from 'mobx-react';
import { BankOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { tF, tT } from '../../../../translate';
import TariffsStyles from '../../m_styles.less';

interface ITariffItemAssignedCompanies {
    companies?: { id: string; name: string }[];
}

export const TariffItemAssignedCompanies: React.FC<ITariffItemAssignedCompanies> = observer(
    ({ companies }: ITariffItemAssignedCompanies) => {
        return (
            <div className={TariffsStyles.tariffItemAssignedItems}>
                <h2 className={TariffsStyles.header2}>{tF('Companies With Access')}</h2>
                {companies?.length ? (
                    companies?.map((value) => {
                        return (
                            <div key={value.id} className={TariffsStyles.item}>
                                <BankOutlined />
                                {value.name}
                            </div>
                        );
                    })
                ) : (
                    <div className={TariffsStyles.noItems}>
                        <InfoCircleOutlined /> {tT('No companies assigned to this tariff')}
                    </div>
                )}
            </div>
        );
    },
);
